import store from "@frameworks/web/redux/store";
import { LIMITS_DATA, LIMITS_ERROR_DATA, LIMITS_HIDE_ERROR_DATA, LIMITS_START_LOADER, LIMITS_STOP_LOADER, } from "../interface/ILimits";
class LimitsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getLimits(limits) {
        this.dispatch({
            type: LIMITS_DATA,
            payload: { limits },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: LIMITS_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: LIMITS_HIDE_ERROR_DATA,
        });
    }
    loader() {
        this.dispatch({
            type: LIMITS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: LIMITS_STOP_LOADER,
        });
    }
}
export default LimitsActions;
